import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 2.2C4.79675 2.2 2.2 4.79675 2.2 8C2.2 11.2033 4.79675 13.8 8 13.8C11.2033 13.8 13.8 11.2033 13.8 8C13.8 4.79675 11.2033 2.2 8 2.2ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8 4.84C8.33137 4.84 8.6 5.10863 8.6 5.44V8C8.6 8.33137 8.33137 8.6 8 8.6C7.66863 8.6 7.4 8.33137 7.4 8V5.44C7.4 5.10863 7.66863 4.84 8 4.84ZM7.4 10.56C7.4 10.2286 7.66863 9.96 8 9.96H8.0064C8.33777 9.96 8.6064 10.2286 8.6064 10.56C8.6064 10.8914 8.33777 11.16 8.0064 11.16H8C7.66863 11.16 7.4 10.8914 7.4 10.56Z"
	})
});
export default SvgWarning;
